import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, unref as _unref, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "s20" }
const _hoisted_3 = { class: "widget shadow-100 pb-2" }
const _hoisted_4 = { class: "container-full-2 s20 my-5" }
const _hoisted_5 = { class: "s13 flex justify-content-right" }
const _hoisted_6 = { class: "form-field-floating default sm s4_mobile ml-3" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-field-floating default sm s4_mobile ml-3" }
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "custom-filter-set-area"
}
const _hoisted_11 = { class: "grid-filter6 mt-4 mb-0" }
const _hoisted_12 = { class: "form-field-floating reactive sm" }
const _hoisted_13 = { class: "form-field-floating reactive sm" }
const _hoisted_14 = { class: "form-field-floating reactive sm" }
const _hoisted_15 = { class: "form-field-floating sm" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "form-field-floating sm" }
const _hoisted_18 = ["loading"]
const _hoisted_19 = ["loading"]
const _hoisted_20 = { class: "table separator skin1 sm selection" }
const _hoisted_21 = {
  class: "btn-circle",
  for: "check-list1"
}
const _hoisted_22 = ["checked"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { colspan: "11" }
const _hoisted_25 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_26 = { class: "selection-item" }
const _hoisted_27 = ["for"]
const _hoisted_28 = ["id", "value"]
const _hoisted_29 = { class: "font-semibold text-xl" }
const _hoisted_30 = { class: "font-semibold text-xl text-center" }
const _hoisted_31 = { class: "text-xl text-center" }
const _hoisted_32 = { class: "text-xl text-center" }
const _hoisted_33 = { class: "font-semibold text-center" }
const _hoisted_34 = { style: {"display":"flex","flex-direction":"row","justify-content":"center"} }

import { computed, onMounted, reactive, ref, toRaw } from 'vue';
    import axios from 'axios';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import { formatAmount, formatDate } from '@/utils';
    import { useRoute } from 'vue-router';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'CartesListView',
  setup(__props) {

    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const itemsList = ref([] as any[]);
    const selectedItem = ref(null as any);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return itemsList.value.length == selectedItems.value.length;
    });
    const startupInfos = reactive({
        status_carte: {} as any,
        banques: [] as any[],
        lots: [] as any[],
    });
    const queryParams = reactive({
        pageNumber: 1,
        sortDir: 'ASC',
        sortColumn: 'numero',
        sortOption: 'numero_asc',
        borneInf: '',
        borneSup: '',
        banque_id: '',
        statut: '',
        num_lot: '',
        search: '',
        trashed: 0
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const SORT_OPTIONS = [
        { value: 'numero_asc', label: 'Numero (ASC)', sort_column: 'numero', sort_direction: 'ASC' },
        { value: 'numero_desc', label: 'Numero (DESC)', sort_column: 'numero', sort_direction: 'DESC' },
        { value: 'created_at_asc', label: 'Date (ASC)', sort_column: 'created_at', sort_direction: 'ASC' },
        { value: 'created_at_desc', label: 'Date (DESC)', sort_column: 'created_at', sort_direction: 'DESC' },
        { value: 'date_expiration_asc', label: 'Date Expiration (ASC)', sort_column: 'date_expiration', sort_direction: 'ASC' },
        { value: 'date_expiration_desc', label: 'Date Expiration (DESC)', sort_column: 'date_expiration', sort_direction: 'DESC' },
    ];
    const showAdvancedFilters = ref(false);
    const loadingExportToExcel = ref(false);
    const loadingExportToPdf = ref(false);

    onMounted(() => {
        const startupDatas: any = route.meta.startup_infos;
        Object.assign(startupInfos, startupDatas);
        doListItems();
    });

    function getCartesStatutClassName(carte: any) {
        switch(carte.statut) {
            case 'delivery':
                return 'success';
            case 'delivering':
                return 'info';
            case 'inactif':
                return 'danger';
            default:
                return 'warning';
        }
    }

    async function doListItems() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const httpResponse = await axios.get(`/backoffice/cartes/list?${queryString}`);
            itemsList.value = httpResponse.data.data;
            pagination.total = httpResponse.data.total;
            pagination.per_page = httpResponse.data.per_page;
            pagination.last_page = httpResponse.data.last_page;
        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    function onPaginate(pageNumber: number) {
        queryParams.pageNumber = pageNumber;
        doListItems();
    }

    async function doDeleteItem(item: any) {
        const confirmation = await confirmationModalRef.value?.open("Cartes", "Voulez-vous vraiment supprimer l'élément sélectionné ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/cartes/destroy/${item.id}`, {});
                const index = itemsList.value.findIndex(i => i.id == item.id);
                if (index > -1) {
                    const itemsListCloned = itemsList.value;
                    itemsListCloned.splice(index, 1);
                    itemsList.value = itemsListCloned;
                }
            } catch(error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = itemsList.value.map(i => i.id);
        } else {
            selectedItems.value = [];
        }
    }

    function onFiltersChanged() {
        const sortItem = SORT_OPTIONS.find(o => o.value == queryParams.sortOption);
        if (sortItem) {
            queryParams.sortColumn = sortItem.sort_column;
            queryParams.sortDir = sortItem.sort_direction;
        }
        doListItems();
    }

    function toggleAdvancedFilters() {
        showAdvancedFilters.value = !showAdvancedFilters.value;
    }

    async function doExportToExcelAction() {
        try {
            loadingExportToExcel.value = true;
            errorMessage.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const response = await axios.get(`/backoffice/cartes/export_excel?${queryString}`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'cartes.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loadingExportToExcel.value = false;
        }
    }

    async function doExportToPdfAction() {
        try {
            loadingExportToPdf.value = true;
            errorMessage.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const response = await axios.get(`/backoffice/cartes/export_pdf?${queryString}`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'cartes.pdf');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loadingExportToPdf.value = false;
        }
    }


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[37] || (_cache[37] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "s7" }, [
              _createElementVNode("h4", { class: "font-semibold mt-4" }, [
                _createTextVNode("Cartes "),
                _createElementVNode("span", { class: "text-sm text-grey-500" }, "(recent)")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, { to: "/app/cartes/form" }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("button", { class: "btn normal ml-4 justify-content-center btn-filtre" }, [
                    _createElementVNode("img", {
                      src: "/icons/icon-add.svg",
                      class: "btn-icon",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Créer")
                  ], -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-input-select",
                  name: "num_lot",
                  id: "num_lot",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.num_lot) = $event)),
                  onChange: onFiltersChanged
                }, [
                  _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, "Tous les lots", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.lots, (option, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: option.num_lot,
                      key: 'filter_num_lot_' + index
                    }, "Lot " + _toDisplayString(option.num_lot), 9, _hoisted_7))
                  }), 128))
                ], 544), [
                  [_vModelSelect, queryParams.num_lot]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-input-select",
                  id: "filters_sort",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.sortOption) = $event)),
                  onChange: onFiltersChanged
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SORT_OPTIONS, (option, index) => {
                    return _createElementVNode("option", {
                      value: option.value,
                      key: 'filter_sort_' + index
                    }, _toDisplayString(option.label), 9, _hoisted_9)
                  }), 64))
                ], 544), [
                  [_vModelSelect, queryParams.sortOption]
                ])
              ]),
              _createElementVNode("button", {
                class: "btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter",
                onClick: toggleAdvancedFilters
              }, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("img", {
                  src: "/icons/icon-filter.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "Options", -1)
              ]))])
            ]),
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
            (showAdvancedFilters.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-input",
                        id: "filters_search",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.search) = $event)),
                        placeholder: "",
                        onKeyup: _withKeys(onFiltersChanged, ["enter"])
                      }, null, 544), [
                        [_vModelText, queryParams.search]
                      ]),
                      _cache[12] || (_cache[12] = _createElementVNode("label", { for: "filters_search" }, "Recherche", -1))
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "form-input",
                        id: "filters_borne_inf",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryParams.borneInf) = $event)),
                        placeholder: "",
                        onChange: onFiltersChanged
                      }, null, 544), [
                        [_vModelText, queryParams.borneInf]
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("label", { for: "filters_borne_inf" }, "Date de création >=", -1))
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "form-input",
                        id: "filters_borne_sup",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryParams.borneSup) = $event)),
                        placeholder: "",
                        onChange: onFiltersChanged
                      }, null, 544), [
                        [_vModelText, queryParams.borneSup]
                      ]),
                      _cache[14] || (_cache[14] = _createElementVNode("label", { for: "filters_borne_sup" }, "Date de création <=", -1))
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-input-select",
                        id: "filter_banque",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((queryParams.banque_id) = $event)),
                        onChange: onFiltersChanged
                      }, [
                        _cache[15] || (_cache[15] = _createElementVNode("option", { value: "" }, "Toutes les banques", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.banques, (option, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: option.id,
                            key: 'filter_banque_' + index
                          }, _toDisplayString(option.nom), 9, _hoisted_16))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, queryParams.banque_id]
                      ]),
                      _cache[16] || (_cache[16] = _createElementVNode("label", { for: "filter_banque" }, [
                        _createTextVNode("Banque "),
                        _createElementVNode("b", { class: "color-danger" }, "*")
                      ], -1))
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-input-select",
                        name: "statut",
                        id: "statut",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((queryParams.statut) = $event)),
                        onChange: onFiltersChanged
                      }, [...(_cache[17] || (_cache[17] = [
                        _createStaticVNode("<option value=\"\" selected>Toutes les cartes</option><option value=\"pending\">En attente</option><option value=\"delivering\">En cours de livraison</option><option value=\"delivery\">Actif</option><option value=\"inactif\">Inactif</option>", 5)
                      ]))], 544), [
                        [_vModelSelect, queryParams.statut]
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("label", { for: "statut" }, [
                        _createTextVNode("Statut "),
                        _createElementVNode("b", { class: "color-danger" }, "*")
                      ], -1))
                    ]),
                    _createElementVNode("button", {
                      class: "btn black normal justify-content-center mx-0 btn-filtre",
                      loading: loadingExportToExcel.value,
                      onClick: doExportToExcelAction
                    }, [...(_cache[19] || (_cache[19] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-excel.svg",
                        class: "btn-icon",
                        alt: ""
                      }, null, -1),
                      _createElementVNode("span", null, "Exporter Excel", -1)
                    ]))], 8, _hoisted_18),
                    _createElementVNode("button", {
                      class: "btn black normal justify-content-center mx-0 btn-filtre",
                      loading: loadingExportToPdf.value,
                      onClick: doExportToPdfAction
                    }, [...(_cache[20] || (_cache[20] = [
                      _createElementVNode("img", {
                        src: "/icons/icon-pdf.svg",
                        class: "btn-icon",
                        alt: ""
                      }, null, -1),
                      _createElementVNode("span", null, "Exporter PDF", -1)
                    ]))], 8, _hoisted_19)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("table", _hoisted_20, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("label", _hoisted_21, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "check_all",
                      checked: areAllItemsSelected.value,
                      onChange: handleCheckAll
                    }, null, 40, _hoisted_22)
                  ])
                ]),
                _cache[23] || (_cache[23] = _createElementVNode("th", null, null, -1)),
                _cache[24] || (_cache[24] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-up.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Numéro")
                ], -1)),
                _cache[25] || (_cache[25] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-none.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Date expiration")
                ], -1)),
                _cache[26] || (_cache[26] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-up.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" N° de Lot")
                ], -1)),
                _cache[27] || (_cache[27] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-down.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Banque")
                ], -1)),
                _cache[28] || (_cache[28] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-none.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Date de création")
                ], -1)),
                _cache[29] || (_cache[29] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-none.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Statut")
                ], -1)),
                _cache[30] || (_cache[30] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-none.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Affectée à")
                ], -1)),
                _cache[31] || (_cache[31] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-none.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Solde")
                ], -1)),
                _cache[32] || (_cache[32] = _createElementVNode("th", { class: "flex-right" }, [
                  _createElementVNode("button", { class: "btn-ultra color2 tips" }, [
                    _createElementVNode("div", { class: "btn-show" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-actif.svg",
                        class: "btn-icon",
                        alt: ""
                      }),
                      _createElementVNode("span", null, "Actif")
                    ]),
                    _createElementVNode("div", { class: "btn-loading" }, [
                      _createElementVNode("div", { class: "loader-dots" })
                    ])
                  ])
                ], -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                    _createElementVNode("td", _hoisted_24, [
                      (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[33] || (_cache[33] = [
                            _createElementVNode("div", { class: "loader dark" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!loading.value)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(itemsList.value, (dataRow, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'row_' + index,
                      class: "text-grey-700 over-effect over-effect-scale"
                    }, [
                      _createElementVNode("td", _hoisted_26, [
                        _createElementVNode("label", {
                          class: "btn-circle",
                          for: 'item_check_' + index
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            name: "selectedItems[]",
                            id: 'item_check_' + index,
                            value: dataRow.id,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedItems).value = $event))
                          }, null, 8, _hoisted_28), [
                            [_vModelCheckbox, selectedItems.value]
                          ])
                        ], 8, _hoisted_27)
                      ]),
                      _cache[34] || (_cache[34] = _createElementVNode("td", null, [
                        _createElementVNode("div", {
                          class: "square-lg px-3 py-3",
                          style: {"background-color":"rgb(var(--color-success-rgb), 0.2)"}
                        }, [
                          _createElementVNode("img", {
                            src: "/icons/icon-menu-carte.svg",
                            width: "100%"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(dataRow.numero), 1),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(dataRow.expiration_annee + '/' + dataRow.expiration_mois), 1),
                      _createElementVNode("td", _hoisted_31, "Lot " + _toDisplayString(dataRow.num_lot ?? '-'), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(dataRow.banque.nom), 1),
                      _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(dataRow.created_at)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['tag-state', getCartesStatutClassName(dataRow), 'stroke'])
                        }, _toDisplayString(dataRow.statut_label), 3)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(dataRow.user ? (dataRow.user.nom + ' ' + dataRow.user.prenom) : '-'), 1),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(_unref(formatAmount)(dataRow.solde)), 1),
                      _cache[35] || (_cache[35] = _createElementVNode("td", { class: "flex-right" }, [
                        _createElementVNode("button", { class: "btn-ultra color2 tips" }, [
                          _createElementVNode("div", { class: "btn-show" }, [
                            _createElementVNode("img", {
                              src: "/icons/icon-actif.svg",
                              class: "btn-icon",
                              alt: ""
                            }),
                            _createElementVNode("span", null, "Actif")
                          ]),
                          _createElementVNode("div", { class: "btn-loading" }, [
                            _createElementVNode("div", { class: "loader-dots" })
                          ])
                        ])
                      ], -1))
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_custom_pagination, {
              modelValue: queryParams.pageNumber,
              "onUpdate:modelValue": [
                _cache[8] || (_cache[8] = ($event: any) => ((queryParams.pageNumber) = $event)),
                onPaginate
              ],
              total: pagination.total,
              "per-page": pagination.per_page,
              last_page: pagination.last_page
            }, null, 8, ["modelValue", "total", "per-page", "last_page"])
          ])
        ]),
        _cache[36] || (_cache[36] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
      ])
    ]),
    _cache[38] || (_cache[38] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
  ]))
}
}

})